export default "__VITE_ASSET__C1zww924__"